import {
	SELECT_COMMENT_TYPE, SHOW_MORE_COMMENTS, UPDATE_MEDIA_DESCRIPTION_VISIBLITY, UPDATE_DOWNLOAD_MENU_VISIBLITY,
	START_SCRUB, UPDATE_SCRUB, FINISH_SCRUB, SHOW_SCRUBBER, GO_TO_COMMENT, FINISH_GO_TO_COMMENT,
	ADD_ERROR, ADD_ERRORS, REMOVE_ERROR, CLEAR_ERRORS,
	START_LOADING, FINISH_LOADING,
	START_COMMENT, START_EDITING_COMMENT, START_COMMENT_REPLY, STOP_EDITING_COMMENT, UPDATE_COMMENT_FIELD,
	UPDATE_CREATE_FORM, CLEAR_CREATE_FORM,
	SHOW_COMMENT_MENU, HIDE_COMMENT_MENU
} from "../reducers/actiontypes";
import { formatTimestamp, findIndex, logEvent } from "../util";

export let selectCommentType = function(type) {
	return {
		type: SELECT_COMMENT_TYPE,
		comment_type: type
	};
}

export let showMediaDescription = function(visible) {
	return {
		type: UPDATE_MEDIA_DESCRIPTION_VISIBLITY,
		visible: visible
	};
}

export let showDownloadMenu = function(visible) {
	return {
		type: UPDATE_DOWNLOAD_MENU_VISIBLITY,
		visible: visible
	};
}

export let showMoreComments = function() {
	return {
		type: SHOW_MORE_COMMENTS
	};
}

export let showScrubber = function(visible) {
	return {
		type: SHOW_SCRUBBER,
		visible: visible
	};
}

export let goToComment = function(objectid) {
	return function(dispatch, getState) {
		var state = getState(),
			comment = state.comments.filter(({objectid:thisid})=>objectid===thisid).pop(),
			index_in_type = comment === undefined ? -1 : state.comments.filter(({comment_type})=>comment_type===comment.comment_type).indexOf(comment);

		if (comment === undefined) {
			return;
		}

		dispatch({
			type: GO_TO_COMMENT,
			highlighted_comment: objectid,
			comment_type: comment.comment_type,
			visible_comments: Math.ceil(index_in_type / 10) * 10
		});
	}
}

export let finishGoToComment = function() {
	return {
		type: FINISH_GO_TO_COMMENT
	};
}

export let toggleMediaDescription = function() {
	return function(dispatch, getState) {
		var showingDescription = getState().ui.show_media_description;

		dispatch(showMediaDescription(!showingDescription));
	}
}

export let toggleDownloadMenu = function() {
	return function(dispatch, getState) {
		var showingDownloadMenu = getState().ui.show_download_menu;

		dispatch(showDownloadMenu(!showingDownloadMenu));
	}
}

export let addError = function(message) {
	return function(dispatch, getState) {
		var debug = getState().ui.debug;

		if (debug) {
			console.log(message);
		}

		dispatch({
			type: ADD_ERROR,
			message: message
		});
	}
}

export let addErrors = function(messages) {
	return function(dispatch, getState) {
		var debug = getState().ui.debug;

		if (debug) {
			for (var i=0; i<messages.length; i++) {
				console.log(messages[i]);
			}
		}

		dispatch({
			type: ADD_ERRORS,
			messages: messages
		});
	}
}

export let removeError = function(index) {
	return {
		type: REMOVE_ERROR,
		index: index
	};
}

export let clearErrors = function() {
	return {
		type: CLEAR_ERRORS
	};
}

export let startLoading = function() {
	return {
		type: START_LOADING
	};
}

export let finishLoading = function() {
	return {
		type: FINISH_LOADING
	};
}

export let startComment = function(comment_type) {
	return function(dispatch, getState) {
		var state = getState(),
			timestamp = state.player.position,
			duration = state.player.duration,
			playing = state.player.playing;

		if (!state.features["add_"+comment_type]) {
			dispatch(addError("You do not have permission to create this type of comment"));
			return;
		}

		dispatch({
			type: START_COMMENT,
			bTimelineComment : timestamp !== 0,
			timestamp : formatTimestamp(timestamp),
			timestamp_editable : duration > 0,
			comment_type : comment_type,
			was_playing : playing
		});
	}
};

export let startEditingComment = function(objectid) {
	return function(dispatch, getState) {
		var state = getState(),
			index = findIndex(state.comments, ({objectid:thisid})=>thisid===objectid),
			comment = state.comments[index],
			duration = state.player.duration;

		dispatch({
			type: START_EDITING_COMMENT,
			index : index,
			body : comment.body,
			bTimelineComment : comment.timestamp !== 0,
			timestamp : formatTimestamp(comment.timestamp),
			timestamp_editable : duration !== 0 && comment.parent_id.length === 0,
			comment_type : comment.comment_type,
			comment_type_editable : false
		});
	}
}

export let startCommentReply = function(objectid) {
	return function(dispatch, getState) {
		var state = getState(),
			playing = state.player.playing,
			index = findIndex(state.comments, ({objectid:thisid})=>thisid===objectid),
			parentid = state.comments[index].parent_id === "" ? objectid : state.comments[index].parent_id,
			parentindex = findIndex(state.comments, ({objectid:thisid})=>thisid===parentid),
			parent = state.comments[parentindex];

		dispatch({
			type: START_COMMENT_REPLY,
			reply_to_index : index,
			parent_index: parentindex,
			bTimelineComment : parent.timestamp !== 0,
			timestamp : formatTimestamp(parent.timestamp),
			comment_type : parent.comment_type,
			was_playing : playing
		});
	}
}

export let updateCommentField = function(field, value) {
	return {
		type: UPDATE_COMMENT_FIELD,
		field: field,
		value: value
	};
}

export let stopEditing = function() {
	return {
		type: STOP_EDITING_COMMENT
	};
}

export let cancelComment = function() {
	return function(dispatch, getState) {
		var was_playing = getState().ui.dialog.was_playing;

		dispatch(stopEditing());

		if (was_playing) {
			window.player.play();
		}
	}
}

export let startChartScrub = function(x, total_width) {
	return {
		type: START_SCRUB,
		x: x,
		total_width: total_width
	};
}

export let updateChartScrub = function(x, total_width) {
	return {
		type: UPDATE_SCRUB,
		x: x,
		total_width: total_width
	};
}

export let finishChartScrub = function() {
	return function(dispatch, getState) {
		var state = getState(),
			scrub = state.ui.scrub,
			duration = state.player.duration;

		dispatch({
			type: FINISH_SCRUB
		});

		window.player.seek(scrub.x/scrub.total_width*duration);
	}
}

export let downloadFile = function(download) {
	return function(dispatch, getState) {
		logEvent({ event: 'download', code:download.code });
	}
}

export let updateCreateForm = function(field, value) {
	return {
		type: UPDATE_CREATE_FORM,
		field: field,
		value: value
	};
}

export let clearCreateForm = function(field, value) {
	return {
		type: CLEAR_CREATE_FORM
	};
}

var hideOnClick = null;
var hideOnKeyPress = null;
export let hideCommentMenu = function(objectid) {
	return function(dispatch, getState) {
		if (hideOnClick !== null) {
			document.removeEventListener("click", hideOnClick);
			hideOnClick = null;
		}
		if (hideOnKeyPress !== null) {
			document.removeEventListener("keypress", hideOnKeyPress);
			hideOnKeyPress = null;
		}

		dispatch({
			type: HIDE_COMMENT_MENU
		});
	}
}

export let showCommentMenu = function(objectid) {
	return function(dispatch, getState) {
		var current_menu_comment = getState().ui.show_comment_menu;

		if (current_menu_comment === objectid) {
			return;
		}

		if (hideOnClick === null) {
			hideOnClick = function({target:{className}}) {
				if (className.split(" ").indexOf("comment-menu") === -1) {
					dispatch(hideCommentMenu());
				}
			};
			document.addEventListener("click", hideOnClick);
		}
		if (hideOnKeyPress === null) {
			hideOnKeyPress = function({which, target:{className}}) {
				if (className.split(" ").indexOf("comment-menu") === -1 && which===27) {
					dispatch(hideCommentMenu());
				}
			}
			document.addEventListener("keypress", hideOnKeyPress);
		}

		dispatch({
			type: SHOW_COMMENT_MENU,
			objectid: objectid
		});
	}
}

export let watchSessionExpiry = function() {
	return function(dispatch, getState) {
		var session_expiry_seconds = getState().ui.session_expiry,
			now_seconds = Math.floor((new Date()).getTime() / 1000),
			until_timeout = (session_expiry_seconds - now_seconds) * 1000;

		setTimeout(function(){
			alert("Your session has timed out. Refresh the page to continue accessing this item.")
		}, until_timeout)
	}
}